/* tslint:disable */
/* eslint-disable */
/**
 * FastAPI
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface AppStopPayload
 */
export interface AppStopPayload {
    [key: string]: any | any;
    /**
     * 
     */
    type: AppStopPayloadTypeEnum;
    /**
     * 
     */
    reason?: string | null;
}


/**
 * @export
 */
export const AppStopPayloadTypeEnum = {
    AppStop: 'app_stop',
} as const;
export type AppStopPayloadTypeEnum = typeof AppStopPayloadTypeEnum[keyof typeof AppStopPayloadTypeEnum];


/**
 * Check if a given object implements the AppStopPayload interface.
 */
export function instanceOfAppStopPayload(value: object): value is AppStopPayload {
    if (!('type' in value) || value['type'] === undefined) return false;
    if (value['type'] !== 'app_stop') return false;
    
    return true;
}

export function AppStopPayloadFromJSON(json: any): AppStopPayload {
    return AppStopPayloadFromJSONTyped(json, false);
}

export function AppStopPayloadFromJSONTyped(json: any, ignoreDiscriminator: boolean): AppStopPayload {
    if (json == null) {
        return json;
    }
    return {
        
            ...json,
        'type': json['type'],
        'reason': json['reason'] === undefined ? undefined : json['reason'] === null ? null : json['reason'],
    };
}

export function AppStopPayloadToJSON(json: any): AppStopPayload {
    return AppStopPayloadToJSONTyped(json, false);
}

export function AppStopPayloadToJSONTyped(value?: AppStopPayload | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
            ...value,
        'type': value['type'],
        'reason': value['reason'],
    };
}

